import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border border-border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 dark:border-border-strong dark:focus:ring-accent",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-ndc-navy text-white hover:bg-ndc-navy/80 dark:bg-surface dark:text-text dark:hover:bg-surface/80",
        secondary:
          "border-transparent bg-surface-muted text-text hover:bg-surface-muted/80 dark:bg-surface-muted dark:text-white dark:hover:bg-surface-muted/80",
        destructive:
          "border-transparent bg-ndc-red text-white hover:bg-ndc-red/80 dark:bg-ndc-red dark:text-white dark:hover:bg-ndc-red/80",
        outline: "text-text dark:text-white",
        success:
          "border-transparent bg-[var(--success-soft)] text-[var(--success)] hover:bg-[var(--success-soft)]",
        warning:
          "border-transparent bg-[var(--warning)]/15 text-[var(--warning)] hover:bg-[var(--warning)]/15",
        error:
          "border-transparent bg-[var(--error-soft)] text-[var(--error)] hover:bg-[var(--error-soft)]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
